export default __webpack_public_path__ + "static/media/icon_destination.1b190484.svg";